"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */

var react_1 = require("react");

var createBreakpoint = function createBreakpoint(breakpoints) {
  if (breakpoints === void 0) {
    breakpoints = {
      laptopL: 1440,
      laptop: 1024,
      tablet: 768
    };
  }

  return function () {
    var _a = react_1.useState(0),
        screen = _a[0],
        setScreen = _a[1];

    react_1.useEffect(function () {
      var setSideScreen = function setSideScreen() {
        setScreen(window.innerWidth);
      };

      setSideScreen();
      window.addEventListener('resize', setSideScreen);
      return function () {
        window.removeEventListener('resize', setSideScreen);
      };
    });
    var sortedBreakpoints = react_1.useMemo(function () {
      return Object.entries(breakpoints).sort(function (a, b) {
        return a[1] >= b[1] ? 1 : -1;
      });
    }, [breakpoints]);
    var result = sortedBreakpoints.reduce(function (acc, _a) {
      var name = _a[0],
          width = _a[1];

      if (screen >= width) {
        return name;
      } else {
        return acc;
      }
    }, sortedBreakpoints[0][0]);
    return result;
  };
};

exports["default"] = createBreakpoint;